<template>
  <div
    v-if="reports.length"
    class="pre-report">
    <div
      class="pre-report__title-wrap"
      style="vertical-align: middle;">
      <div
        class="pre-report__title">
        <span class="pre-report__icon">
          <svg
            class="icon-report svg-icon"
            viewBox="0 0 19 24">
            <path
              class="color1"
              d="M0,23H18v1H0ZM0,12V22H3V12Zm2,9H1V13H2ZM7,8V21H6V8H7M8,7H5V22H8V7Zm4,
                6v8H11V13h1m1-1H10V22h3V12Zm4-4V21H16V8h1m1-1H15V22h3V7ZM17,2.5a.5.5,0,1,
                1-.5-.5A.5.5,0,0,1,17,2.5Zm2,0a2.491,2.491,0,0,1-3.821,2.115L12.492,
                7.382a1.5,1.5,0,1,1-2.26.324l-2.8-2.888a2.428,2.428,0,0,1-2.058-.1L2.636,
                7.531A1.484,1.484,0,0,1,3,8.5,1.5,1.5,0,1,1,1.5,7a1.42,1.42,0,0,1,
                .254.026L4.594,4.1a2.493,2.493,0,1,1,3.673.167l2.741,2.821A1.469,1.469,0,
                0,1,11.488,7L14.462,3.94A2.5,2.5,0,1,1,19,2.5ZM2,8.5a.5.5,0,1,0-.5.5A.5.5,
                0,0,0,2,8.5Zm6-6A1.5,1.5,0,1,0,6.5,4,1.5,1.5,0,0,0,8,2.5Zm4,6a.5.5,0,1,
                0-.5.5A.5.5,0,0,0,12,8.5Zm6-6A1.5,1.5,0,1,0,16.5,4,1.5,1.5,0,0,0,18,
                2.5ZM6.5,2a.5.5,0,1,0,.5.5A.5.5,0,0,0,6.5,2Z" />
          </svg>
        </span>
        確定レポート
      </div>
    </div>
    <div class="pre-report__notice">
      {{ title }}分の分配報告書です。<br>
      各配信ストアの金額、販売数の詳細は
      <router-link
        link
        :to="{ name: 'report-finalized' }"
        class="c-text-link">
        確定レポート
      </router-link>
      でご確認いただけます。
    </div>
    <div class="pre-report__download">
      <finalized-report-download-buttons
        :payment_id="paymentId"
        :reports="reports" />
    </div>
    <template
      v-if="otherReports.length">
      {{ otherTitle }}分の分配報告書です。<br>
      <div class="pre-report__download">
        <finalized-report-download-buttons
          :payment_id="otherPaymentId"
          :reports="otherReports" />
      </div>
    </template>
  </div>
</template>

<script>
import FinalizedReportDownloadButtons from '../../Report/FinalizedReportDownloadButtons'

export default {
  name: 'FinalizedReport',
  components: {
    FinalizedReportDownloadButtons,
  },
  data() {
    return {
      paymentId: 0,
      title: '',
      reports: [],
      otherPaymentId: 0,
      otherTitle: null,
      otherReports: [],
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get('/api/client/reports/finalized/file-list', {
        params: {
          latest: true,
        },
      })
      if ('finalized_reports' in data && data.finalized_reports?.length) {
        this.paymentId = data.payment_id
        this.title = data.title
        this.reports = data.finalized_reports
        this.otherPaymentId = data.other_payment_id ?? null
        this.otherTitle = data.other_title ?? null
        this.otherReports = data.other_finalized_reports ?? []
      }
    },
  },
}
</script>
